import MetaTag from "components/Common/Meta-tag"
import React from "react"
import Breadcrumbs from "components/Common/Breadcrumb"
import { Container } from "reactstrap"
import Form from "./Form"

function CreateInspectionDocs() {
  return (
    <div>
      <MetaTag title={"Create Inspect"} />

      <div className="page-content">
        <Breadcrumbs
          title="Dashboard"
          breadcrumbItem="Create Inspect"
        />
        <Container fluid>
          <div className="container-fluid">
            <Form />
          </div>
        </Container>
      </div>
    </div>
  )
}

export default CreateInspectionDocs
